import { render, staticRenderFns } from "./CanvasAttr.vue?vue&type=template&id=7c40ef6d&"
import script from "./CanvasAttr.vue?vue&type=script&lang=js&"
export * from "./CanvasAttr.vue?vue&type=script&lang=js&"
import style0 from "./CanvasAttr.vue?vue&type=style&index=0&id=7c40ef6d&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports